/* istanbul ignore file */
import { useAnalytics } from 'core/analytics/hooks';
import { useServices } from './useServices';

export const useCookieConsent = () => {
  const { trackCustomEvent } = useAnalytics();
  const { cookieConsentService } = useServices();

  const toggleReconsent = () => {
    cookieConsentService.toggleReconsent();
    trackCustomEvent('funnel_screen_click', {
      screen_context: 'consent_settings',
      funnel_platform: 'AppNebula',
    });
  };

  return {
    toggleReconsent,
  };
};
